import ServiceRegistry from "core/util/ServiceRegistry";
import ArticlePlaylist from "../entities/ArticlePlaylist";
import AppToaster from "core/util/AppToaster";

export function toggleBookMark(id, forceRefresh) {
	const articleId = {
		articleId: Number(id)
	} as any;
	ServiceRegistry.getMutationService()
		.create(articleId, ArticlePlaylist)
		.then(res => {
			forceRefresh();
		})
		.catch(err => {
			AppToaster.show({
				message: err.message,
				intent: "danger"
			});
		});
}



// WEBPACK FOOTER //
// ./src/panels/kb/article/arcticleActions.ts